module.exports = __webpack_public_path__ + "img/4.702735cc.png";